import { BaseService } from "mrb/core";
import { LoadioAlbumApiRouteService } from "common/services";

class LoadioAlbumService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LoadioAlbumApiRouteService());
    }

    getAllSongs(id, options = {}, abortSignal = null) {
        const url = this.routeService.getAllSongs(id, options);
        return this.apiClient.get(url, null, abortSignal);
    }

    updateActiveStatus(id, value, abortSignal = null) {
        const url = this.routeService.updateActiveStatus(id, value);
        return this.apiClient.put(url, null, null, abortSignal);
    }
}

export default LoadioAlbumService;
